import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'src/components/app-ui'

const field = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '10px 12px',
  border: `1px solid ${colors.borderSoft}`,
  borderRadius: '8px',
  outline: 'none',
  background: '#FFFFFF',
  fontFamily: 'inherit',
  fontSize: '14px',
  fontWeight: 400,
  color: colors.navy,
  '&:focus': {
    borderColor: colors.primary,
  },
}

const menuShadow =
  '0 12px 24px -4px rgba(145,158,171,.24), 0 0 2px rgba(145,158,171,.3)'

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '20px',
    alignItems: 'start',
  },
  gridWide: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
    gap: '20px',
    alignItems: 'start',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    minWidth: 0,
  },
  panel: {
    overflow: 'hidden',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '20px 24px',
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  listHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    padding: '16px 20px',
    borderBottom: `1px solid ${colors.border}`,
  },
  listSub: {
    marginTop: 2,
    fontSize: '13px',
    color: colors.muted,
  },
  addWrap: {
    position: 'relative',
    flex: 'none',
  },
  addButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '7px 12px',
    border: '1px solid rgba(1,95,251,.5)',
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
    whiteSpace: 'nowrap',
  },
  addMenu: {
    position: 'absolute',
    right: 0,
    top: 'calc(100% + 6px)',
    zIndex: 20,
    width: 260,
    display: 'flex',
    flexDirection: 'column',
    padding: '6px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    background: '#FFFFFF',
    boxShadow: menuShadow,
  },
  addOption: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '10px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
    '&:hover': {
      background: colors.hover,
    },
  },
  addOptionTitle: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    color: colors.navy,
  },
  addOptionDesc: {
    display: 'block',
    marginTop: 2,
    fontSize: '12px',
    color: colors.muted,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px 10px 16px',
    borderBottom: '1px solid #F1F3F5',
    background: '#FFFFFF',
    fontSize: '14px',
    color: colors.navy,
    '&:hover': {
      background: '#FAFBFC',
    },
  },
  rowDragging: {
    opacity: 0.4,
  },
  rowOver: {
    boxShadow: `inset 0 2px 0 ${colors.primary}`,
  },
  grip: {
    display: 'inline-flex',
    color: colors.disabled,
    cursor: 'grab',
  },
  gripPlaceholder: {
    width: 16,
    flex: 'none',
  },
  rowIcon: {
    width: 32,
    height: 32,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    background: colors.hover,
    color: colors.muted,
  },
  rowMain: {
    flex: 1,
    minWidth: 0,
  },
  rowLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 500,
  },
  rowInfo: {
    display: 'inline-flex',
    flex: 'none',
    marginLeft: -2,
    cursor: 'help',
    color: colors.subtle,
  },
  rowNote: {
    padding: '1px 7px',
    borderRadius: '999px',
    background: colors.hover,
    fontSize: '11px',
    fontWeight: 500,
    color: colors.muted,
  },
  rowTarget: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '12px',
    color: colors.subtle,
  },
  toggleSlot: {
    width: 36,
    flex: 'none',
    display: 'inline-flex',
  },
  menuSlot: {
    position: 'relative',
    width: 32,
    flex: 'none',
  },
  moreButton: {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.muted,
    '&:hover': {
      background: colors.hover,
      color: colors.navy,
    },
  },
  rowMenu: {
    width: 160,
    padding: '4px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    boxShadow: menuShadow,
  },
  rowMenuItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 10px',
    border: 0,
    borderRadius: '6px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    textAlign: 'left',
    color: colors.navy,
    '&:hover': {
      background: colors.hover,
    },
  },
  rowMenuDanger: {
    color: colors.error,
    '&:hover': {
      background: 'rgba(237,66,69,.06)',
    },
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  fieldTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.navy,
  },
  help: {
    fontSize: '12px',
    fontWeight: 400,
    color: colors.muted,
  },
  helpError: {
    fontSize: '12px',
    fontWeight: 400,
    color: colors.error,
  },
  input: field,
  inputMono: {
    ...field,
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
  },
  inputError: {
    borderColor: colors.error,
    '&:focus': {
      borderColor: colors.error,
    },
  },
  textarea: {
    ...field,
    resize: 'vertical',
  },
  slugField: {
    display: 'flex',
    overflow: 'hidden',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '8px',
  },
  slugPrefix: {
    padding: '10px 4px 10px 12px',
    background: colors.hover,
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    fontWeight: 400,
    color: colors.muted,
    whiteSpace: 'nowrap',
  },
  slugInput: {
    flex: 1,
    minWidth: 0,
    padding: '10px 12px 10px 2px',
    border: 0,
    outline: 'none',
    background: colors.hover,
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    color: colors.navy,
  },
  slugLocked: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    borderRadius: '8px',
    background: 'rgba(75,70,92,.08)',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    fontWeight: 400,
    color: colors.muted,
  },
  miniToggle: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  miniTrack: {
    position: 'relative',
    width: 30,
    height: 17,
    flex: 'none',
    borderRadius: '999px',
  },
  miniKnob: {
    position: 'absolute',
    top: 2,
    width: 13,
    height: 13,
    borderRadius: '50%',
    background: '#FFFFFF',
    boxShadow: '0 1px 2px rgba(0,0,0,.2)',
  },
  dialogBackdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    background: 'rgba(0,0,0,.48)',
  },
  dialog: {
    width: 460,
    maxWidth: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '24px',
    borderRadius: '16px',
    background: '#FFFFFF',
    boxShadow: '0 24px 48px -8px rgba(0,0,0,.24)',
    color: colors.navy,
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  dialogHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  dialogTitle: {
    fontSize: '18px',
    fontWeight: 600,
  },
  dialogSub: {
    marginTop: 4,
    fontSize: '13px',
    color: colors.muted,
  },
  dialogClose: {
    display: 'inline-flex',
    padding: 4,
    border: 0,
    borderRadius: '6px',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.muted,
    '&:hover': {
      background: colors.hover,
    },
  },
  dialogActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingTop: 4,
  },
  spacer: {
    flex: 1,
  },
  btnOutline: {
    padding: '9px 16px',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  btnPrimary: {
    padding: '9px 16px',
    border: 0,
    borderRadius: '8px',
    background: colors.primary,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#FFFFFF',
    '&:disabled': {
      background: colors.disabled,
      cursor: 'not-allowed',
    },
  },
  btnDanger: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '9px 14px',
    border: '1px solid rgba(237,66,69,.4)',
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.error,
  },
  pagePicker: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '8px',
  },
  pageOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 12px',
    border: 0,
    borderBottom: '1px solid #F1F3F5',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  pageOptionOn: {
    background: 'rgba(1,95,251,.06)',
  },
  radio: {
    width: 16,
    height: 16,
    flex: 'none',
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: `1.5px solid ${colors.disabled}`,
  },
  radioOn: {
    border: `5px solid ${colors.primary}`,
  },
  pageOptionName: {
    flex: 1,
    fontSize: '14px',
    fontWeight: 500,
    color: colors.navy,
  },
  pageOptionPath: {
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '12px',
    color: colors.subtle,
  },
  newPageOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 12px',
    border: 0,
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'left',
    color: colors.primary,
    '&:hover': {
      background: 'rgba(1,95,251,.06)',
    },
  },
  colorRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  swatch: {
    width: 28,
    height: 28,
    padding: 0,
    border: '1px solid rgba(145,158,171,.4)',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  hexField: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginLeft: 4,
    padding: '5px 8px',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '8px',
  },
  hexChip: {
    width: 16,
    height: 16,
    flex: 'none',
    borderRadius: '4px',
    border: '1px solid rgba(145,158,171,.4)',
  },
  hexInput: {
    width: 72,
    border: 0,
    outline: 'none',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '12px',
    color: colors.navy,
    textTransform: 'uppercase',
  },
  contrast: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '10px 12px',
    borderRadius: '8px',
    background: 'rgba(251,157,1,.1)',
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#8A5600',
    '& a': {
      color: '#8A5600',
      fontWeight: 600,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  divider: {
    height: 1,
    background: '#F1F3F5',
  },
  settingRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  settingDesc: {
    fontSize: '13px',
    color: colors.muted,
  },
  headerBar: {
    minHeight: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    padding: '16px 28px',
  },
  previewLogo: {
    display: 'block',
    maxWidth: 280,
    objectFit: 'contain',
    objectPosition: 'left center',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  brandMark: {
    width: 18,
    height: 18,
    flex: 'none',
    borderRadius: '5px',
    background: colors.primary,
    objectFit: 'contain',
  },
  // Header preview: the white logo tile and the round profile button.
  brandTile: {
    width: 24,
    height: 24,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid transparent',
    borderRadius: '6px',
    background: '#FFFFFF',
    '& $brandMark': {
      width: 12,
      height: 12,
      borderRadius: '3px',
    },
  },
  signInButton: {
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    height: 32,
    padding: '0 14px',
    borderRadius: '999px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  profileButton: {
    width: 32,
    height: 32,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  brandName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '13px',
    fontWeight: 600,
  },
  headerMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  stripes: {
    height: 28,
    background:
      'repeating-linear-gradient(45deg,#F4F6F8 0 8px,#FAFBFC 8px 16px)',
  },
  previewHead: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    borderBottom: `1px solid ${colors.border}`,
    fontSize: '13px',
    color: colors.muted,
  },
  previewStage: {
    padding: '20px',
    background: colors.hover,
  },
  footerFrame: {
    overflow: 'hidden',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    boxShadow: '0 12px 24px -4px rgba(145,158,171,.12)',
  },
  footerStripes: {
    height: 36,
    background:
      'repeating-linear-gradient(45deg,#EEF1F4 0 8px,#F7F8FA 8px 16px)',
  },
  footerBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '24px 28px',
    borderTop: '1px solid rgba(145,158,171,.2)',
  },
  footerTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '20px',
  },
  footerLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '18px',
    fontSize: '13px',
  },
  footerSocials: {
    display: 'flex',
    gap: '12px',
  },
  footerCopy: {
    paddingTop: 14,
    borderTop: '1px solid rgba(145,158,171,.25)',
    fontSize: '12px',
    opacity: 0.7,
  },
  socialLabel: {
    width: 84,
    flex: 'none',
    fontSize: '14px',
    fontWeight: 500,
  },
  socialInput: {
    ...field,
    flex: 1,
    minWidth: 0,
    padding: '8px 10px',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
  },
  socialRemove: {
    width: 32,
    height: 32,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.muted,
    '&:hover': {
      background: 'rgba(237,66,69,.06)',
      color: colors.error,
    },
  },
  socialAdd: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 16px',
  },
  socialAddLabel: {
    marginRight: 4,
    fontSize: '12px',
    color: colors.muted,
  },
  socialChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 11px',
    border: `1px solid ${colors.border}`,
    borderRadius: '999px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    color: colors.navy,
    '&:hover': {
      borderColor: colors.primary,
      color: colors.primary,
    },
  },
  appearance: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 20px 20px',
  },
  seoGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 640px)',
    gap: '20px',
    alignItems: 'start',
  },
  dropzone: {
    position: 'relative',
    height: 96,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    overflow: 'hidden',
    border: '2px dashed rgba(1,95,251,.5)',
    borderRadius: '10px',
    background: 'rgba(1,95,251,.06)',
    cursor: 'pointer',
    fontSize: '13px',
    color: colors.primary,
    '& input': {
      position: 'absolute',
      inset: 0,
      opacity: 0,
      cursor: 'pointer',
    },
  },
  dropzoneImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  imageActions: {
    display: 'flex',
    gap: '12px',
  },
  seoActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 4,
  },
  linkButton: {
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
  },
  linkDanger: {
    color: colors.error,
  },
  empty: {
    padding: '16px 20px',
    fontSize: '13px',
    color: colors.subtle,
  },
})

export default useStyles
